module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/symbol-observable/index.js
// module id = 2291
// module chunks = 63